import { render, staticRenderFns } from "./ringer.vue?vue&type=template&id=7dca857d&"
import script from "./ringer.vue?vue&type=script&lang=js&"
export * from "./ringer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports